import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'vue-cookies';

import common from '@/common/common.js'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        langcur: common.basic.chstr2int(Cookie.get('lang'), 1),
        langdic: common.json.sync('/include/dic2.json'),
        config: common.json.sync('/include/config.json'),
        logourl: '',
        face: '',
        showname: '',
        mymobile: '',
        islogintt: common.basic.chstr2int(Cookie.get('islogintt')),
        memlev: 0,
        tranurl: '/member',
        topnav: 1,
        isfull: false,
        topnavsort: 1,
        wh: window.innerHeight,// document.body.clientHeight;
        ww: window.innerWidth// document.body.clientWidth;
    },
    getters: {
        isstu: state => state.memlev == 1,
        istea: state => state.memlev == 2,
        issmall: state => state.ww <= 800,
        istiny: state => state.ww <= 480
    },
    mutations: {
        SET_islogin(state, v) {
            if (state.islogintt != v) {
                state.islogintt = v;
                Cookie.set('islogintt', v, -1);
            }

        },
        SET_LANGCUR(state, v) {
            if (state.langcur != v) {
                state.langcur = v;
                Cookie.set('lang', v, -1);
            }
        },
        SET_LOGOURL(state, v) {
            if (state.logourl != v) {
                state.logourl = v;
            }
        },
        SET_MEMLEV(state, v) {
            if (state.memlev != v) {
                state.memlev = v;
                Cookie.set('memlev', v, -1);
            }
        },
        SET_SHOWNAME(state, v) {
            if (state.showname != v) {
                state.showname = v;
            }

        },
        SET_FACE(state, v) {
            if (state.face != v) {
                state.face = v;
            }

        },
        SET_MYMOBILE(state, v) {
            if (state.mymobile != v) {
                state.mymobile = v;
            }

        },
        SET_TRANURL(state, v) {
            if (state.tranurl != v) {
                state.tranurl = v || '/member';
            }

        },
        SET_TOPNAV(state, v) {
            if (state.topnav != v) {
                state.topnav = v;
                state.isfull = v >= 100;
                state.topnavsort = state.isfull ? v / 100 : v;
            }

        },
        SET_WINDOWSIZE(state) {
            state.wh = window.innerHeight;// document.body.clientHeight;
            state.ww = window.innerWidth;// document.body.clientWidth;
        }/*,
        SET_LANGDIC(state, v) {//动态加载字典，现用同步加载
            state.langdic = v;
        }*/
    },
    actions: {
        setislogin({ commit }, v) {
            commit('SET_islogin', v);
        },
        setlangcur({ commit }, v) {
            commit('SET_LANGCUR', v);
        },
        setlogourl({ commit }, v) {
            commit('SET_LOGOURL', v);
        },
        setmemlev({ commit }, v) {
            commit('SET_MEMLEV', v);
        },
        setshowname({ commit }, v) {
            commit('SET_SHOWNAME', v);
        },
        setface({ commit }, v) {
            commit('SET_FACE', v);
        },
        setmobile({ commit }, v) {
            commit('SET_MYMOBILE', v);
        }
        /*,
        setlangdic({ commit }) {
        common.fetchjson('/include/dic.json', res => {
            commit('SET_LANGDIC', res);
        });
        }*/
    }
});

export default store;
